import * as types from './agenda-items.types';
import * as constants from './agenda-items.constants';
import { DropResult } from 'react-beautiful-dnd';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IAgendaItem } from '../../../resource/agenda-item/agenda-item.types';

export const storeAgendaItems = (agendaItems: types.IAgendaItems): types.IStoreAgendaItems => ({
  type: constants.STORE_AGENDA_ITEMS,
  payload: agendaItems,
});

export const clearAgendaItems = (): types.IClearAgendaItems => ({
  type: constants.CLEAR_AGENDA_ITEMS,
});

export const changeOrderAgendaItem = (
  meetingId: IMeetingSimple['id'],
  dropResult: DropResult,
): types.IChangeOrderAgendaItem => ({
  type: constants.CHANGE_ORDER_AGENDA_ITEM,
  payload: {
    meetingId,
    dropResult,
  },
});

export const getAgendaItems = (meetingId?: IMeetingSimple['id']): types.IGetAgendaItems => ({
  type: constants.GET_AGENDA_ITEMS,
  payload: meetingId,
});

export const saveAgendaItems = (
  meetingId: IMeetingSimple['id'],
  agendaItems: IAgendaItem[],
): types.ISaveAgendaItems => ({
  type: constants.SAVE_AGENDA_ITEMS,
  payload: {
    meetingId,
    agendaItems,
  },
});

export const storeCurrentAgenda = (currentAgendaIndex: types.ICurrentAgendaIndex): types.IStoreCurrentAgenda => ({
  type: constants.STORE_CURRENT_AGENDA_INDEX,
  payload: currentAgendaIndex,
});

export const clearCurrentAgenda = (): types.IClearCurrentAgenda => ({
  type: constants.CLEAR_CURRENT_AGENDA_INDEX,
});

export const moveStepAgenda = (currentAgendaIndex: types.ICurrentAgendaIndex): types.IMoveToNextAgenda => ({
  type: constants.MOVE_STEP_AGENDA,
  payload: currentAgendaIndex,
});
